import React from "react";
import { Helmet } from "react-helmet-async";

const Asansol = () => {
  return (
    <>
      <Helmet>
        <title>Fly Ash Bricks, Blocks & Paver Blocks in Asansol | Anil Flyash Bricks</title>
        <meta
          name="description"
          content="Anil Flyash Bricks is a trusted manufacturer and supplier of fly ash bricks, blocks, and paver blocks in Asansol, Raniganj, and Barakar. Get durable, eco-friendly, and affordable bricks for your next project."
        />
        <meta
          name="keywords"
          content="fly ash bricks in Asansol, paver blocks in Asansol, fly ash blocks Asansol, brick dealers Asansol, flyash brick manufacturer Asansol, paver block supplier Asansol, Anil Flyash Bricks Asansol"
        />
        <link rel="canonical" href="https://anilbricks.com/flyash-bricks-in-asansol" />
      </Helmet>

      <div className="py-16 px-6 md:px-20 bg-gray-50 text-gray-800">
        <h1 className="text-3xl font-bold mb-6 text-green-700 text-center">
          Fly Ash Bricks, Blocks & Paver Blocks in Asansol
        </h1>

        <p className="text-lg leading-relaxed mb-4">
          <strong>Anil Flyash Bricks</strong> proudly serves the industrial hub of{" "}
          <strong>Asansol</strong> as a leading manufacturer and supplier of{" "}
          <strong>fly ash bricks, fly ash blocks, and high-quality paver blocks</strong>.
          Our mission is to provide eco-friendly construction materials that ensure
          durability, cost-efficiency, and sustainability for modern building projects.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          Every brick and block we produce goes through a quality-controlled process
          using advanced machinery and the latest curing techniques. Builders and
          contractors across <strong>Asansol, Raniganj, Barakar, and Kulti</strong> trust
          our brand for reliable strength, accurate dimensions, and a smooth finish that
          simplifies construction work.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          Our <strong>fly ash bricks</strong> are not only eco-friendly but also more
          durable and water-resistant than traditional clay bricks. Similarly, our{" "}
          <strong>fly ash blocks</strong> offer lightweight strength that reduces load on
          structures and speeds up construction time. For outdoor use, our{" "}
          <strong>paver blocks</strong> are designed to handle heavy loads and harsh
          weather, making them ideal for driveways, footpaths, and industrial areas.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          Whether you're developing a residential complex, industrial facility, or
          commercial property, Anil Flyash Bricks provides materials that meet your
          quality standards. We are committed to delivering on time with full
          transparency and customer satisfaction.
        </p>

        <p className="text-lg leading-relaxed mb-6">
          If you are looking for the <em>best fly ash brick manufacturer in Asansol</em> or
          a trusted <em>paver block supplier near Raniganj or Kulti</em>, look no further.
          Choose <strong>Anil Flyash Bricks</strong> — your partner in building a
          sustainable, stronger future.
        </p>

        <div className="text-center">
          <a
            href="/#contact"
            className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-full font-semibold shadow-md transition"
          >
            Get a Free Quote
          </a>
        </div>
      </div>
    </>
  );
};

export default Asansol;
